export default __webpack_public_path__ + "static/media/SB_Rectangle2.9b3cb46f.svg";